<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="视频id" prop="videoId" >-->
<!--        <a-input v-model="form.videoId" placeholder="请输入视频id" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item
        v-for="item in nameFields"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
      >
        <a-input v-model="form[item.prop]" :placeholder="'请输入' + item.label" />
      </a-form-model-item>
      <a-form-model-item label="演员头像" prop="performerAvatar" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.performerAvatar"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          :customRequest="handleChange"
        >
          <div v-if="form.performerAvatar" class="upload-image-wrapper">
            <img :src="form.performerAvatar" alt="logo"
                 style="height:104px;max-width:300px"/>
            <div v-if="uploadLoading" class="upload-mask">
              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>
            </div>
          </div>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort" >
        <a-input-number :min="0" :precision="0" v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
<!--      <a-form-model-item label="是否禁用 0-否 1-是" prop="isBan" >-->
<!--        <a-input v-model="form.isBan" placeholder="请输入是否禁用 0-否 1-是" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入备注" />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVideoPerformer, addVideoPerformer, updateVideoPerformer } from '@/api/videoPerformer/videoPerformer'
import UploadFileToVOD from '@/api/vod.js'

const NAME_FIELDS = [
  { label: '演员姓名（中文简体）', prop: 'performerName' },
  { label: '演员姓名（英文）', prop: 'performerNameEn' },
  { label: '演员姓名（繁体中文）', prop: 'performerNameTc' },
  { label: '演员姓名（法语）', prop: 'performerNameFr' },
  { label: '演员姓名（越南语）', prop: 'performerNameVi' },
  { label: '演员姓名（韩语）', prop: 'performerNameKo' },
  { label: '演员姓名（阿拉伯语）', prop: 'performerNameAb' },
  { label: '演员姓名（日语）', prop: 'performerNameJp' }
]

const buildNameForm = () => {
  const fields = {}
  NAME_FIELDS.forEach(item => {
    fields[item.prop] = null
  })
  return fields
}

const buildNameRules = () => {
  const rules = {}
  NAME_FIELDS.forEach(item => {
    rules[item.prop] = [{ required: true, message: item.label + '不能为空', trigger: 'blur' }]
  })
  return rules
}

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      videoId: null,
      nameFields: NAME_FIELDS,
      // 表单参数
      form: {
        id: null,
        videoId: null,
        ...buildNameForm(),
        performerAvatar: null,
        sort: null,
        isBan: null,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      uploadLoading: false,
      rules: {
        ...buildNameRules(),
        performerAvatar: [
          { required: true, message: '演员头像不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    beforeUpload (file) {
      const fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading = false
        return false
      }
      this.form.performerAvatar = ''
      this.uploadLoading = true
    },
    onClose () {
      this.open = false
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        videoId: null,
        ...buildNameForm(),
        performerAvatar: null,
        sort: null,
        isBan: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (videoId) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.form.videoId = videoId
      this.videoId = videoId
      console.log(this.videoId)
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids,videoId) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVideoPerformer({"id":id}).then(response => {
        this.form = response.data
        this.form.videoId = videoId
        this.videoId = videoId
        console.log(this.videoId)
        this.open = true
        this.formTitle = '修改'
        // 清除表单验证状态
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      })
    },

    handleChange(info) {
      let that = this
      that.uploadLoading = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.performerAvatar = fileName[0];//文件名
          that.uploadLoading = false;
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('performerAvatar')
            }
          })
        },
        error: function () {
          that.uploadLoading = false;
          that.$message.error('上传失败，请重试');
        }
      });
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(11111111111)
      console.log(this.videoId)

      this.form.videoId=this.videoId
      console.log(this.form)
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            this.form.videoId=this.videoId
            updateVideoPerformer(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            this.form.videoId=this.videoId
            console.log(this.form)
            console.log(this.videoId)
            addVideoPerformer(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.upload-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.avatar-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 104px;
    height: 104px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
